import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class StatusService {
    totalTiming = 370 // in second
    liveInterval;
    liveSecond = 0;
    liveSecondSub: BehaviorSubject<Number>;

    // liveMessages;
    liveMessageUpdate:BehaviorSubject<string>;
    isSchedule;
    orderDetails;
    orderId;
    isProcessComplated:BehaviorSubject<boolean>;
    

    public statusTempData = [
        { id: 1, title: 'Order Confirmed', status: 0 }, // undone == 0 || pending == 1 || done == 2
        { id: 2, title: 'Delivery Booked', status: 0 }, // undone == 0 || pending == 1 || done == 2
        { id: 3, title: 'Driver Found', status: 0 }, // undone == 0 || pending == 1 || done == 2
        { id: 4, title: 'Preparing Delivery', status: 0 }, // undone == 0 || pending == 1 || done == 2
    ];

    statusData:BehaviorSubject<any>;

    constructor() { 
        this.liveMessageUpdate = new BehaviorSubject('');
        this.statusData = new BehaviorSubject([]);
        this.liveSecondSub = new BehaviorSubject(0);
        this.isProcessComplated = new BehaviorSubject(false);
    }


    public getOrderData() {  
        if (this.orderDetails.isSchedule == 1) this.isSchedule = 1;
        else this.isSchedule = 0;
    }
 

    processStatuses(timer) { 

        if(timer){
            this.liveSecond = timer; 
            this.liveSecondSub.next(timer);   
        }
        else{
            this.liveSecond = 0;
            this.liveSecondSub.next(0);
        }

        if(!this.liveInterval){
            this.liveInterval = setInterval(() => { 
                
                if(this.liveSecond == 0){
                    this.statusTempData.map(item => {
                        if(item.id == 1){
                            item.status = 1;
                        }else{
                            item.status = 0;
                        }
                    });
                    this.updateStatus(this.statusTempData); 
                }
     
                // First 10 seconds: Sections 1 (10 seconds) completed
                if (this.liveSecond <= 10) {
                    
                    if (this.isSchedule) this.liveMessageUpdate.next("We are confirming your scheduled order, please wait...");
                    else this.liveMessageUpdate.next("Hang tight! We're finding the best available delivery personnel for your delivery");
                    
                    if(this.liveSecond == 10){
                        this.statusTempData.map(item => {
                            if(item.id == 1){
                                item.status = 2;
                            }else if(item.id == 2){
                                item.status = 1;
                            }else{
                                item.status = 0;
                            }
                        }); 
                        this.updateStatus(this.statusTempData);
                    }
                }
                // Next 30 seconds: Sections 2 (30 seconds) completed
                else if (this.liveSecond <= 40) {
                    
                    if (this.isSchedule) this.liveMessageUpdate.next("Your Phlenu delivery is in the process of being scheduled. Please be patient while we secure your slot, which generally takes under 5 minutes. Scheduled orders are either selected by our delivery personnels or allocated the next business day by admin");
                    else this.liveMessageUpdate.next("Your order is in good hands! We're working to connect you with a delivery personnel now."); 
    
    
                    if(this.liveSecond == 40){
                        this.statusTempData.map(item => {
                            if(item.id == 1){
                                item.status = 2;
                            }
                            else if(item.id == 2){
                                item.status = 2;
                            }
                            else if(item.id == 3){
                                item.status = 1;
                            }
                            else{
                                item.status = 0;
                            }
                        }); 
                        this.updateStatus(this.statusTempData);
                    }
                   
    
                }
                // Next 240 seconds: Section 3 active
                else if (this.liveSecond <= 280){
    
                    if (this.liveSecond <= 130) {
                        this.liveMessageUpdate.next("Almost there! We're securing the right delivery personnel to handle your delivery.");
                    }
                    else if(this.liveSecond <= 180){
                        this.liveMessageUpdate.next("We're preparing your delivery. Stay tuned for updates shortly!"); 
                    }
                    else if(this.liveSecond <= 240){
                        this.liveMessageUpdate.next("Thanks for your patience! We're setting things up for a smooth delivery.");    
                    }
                    else{
                        this.liveMessageUpdate.next("We're on it! Finalizing your delivery arrangements now");
                    }
    
                    if(this.liveSecond == 280){
                        this.statusTempData.map(item => {
                            if(item.id == 1){
                                item.status = 2;
                            }
                            else if(item.id == 2){
                                item.status = 2;
                            }
                            else if(item.id == 3){
                                item.status = 2;
                            }
                            else{
                                item.status = 1;
                            }
                        });
               
                        this.updateStatus(this.statusTempData);
                    }
    
                }
                // Next 90 seconds: Section 4 active
                else if(this.liveSecond <= 360){
                    if (this.liveSecond <= 320) {
                        this.liveMessageUpdate.next("Your delivery is important to us! We're arranging the best match for a smooth experience");
                    }
                    else{
                        if(this.isSchedule) this.liveMessageUpdate.next("Contacting Admin, support would reach out & assign a delivery personnel during business hours.");
                        else this.liveMessageUpdate.next("Good things take a moment! A delivery personnel will be with you very soon");
                    }
    
                    if(this.liveSecond == 360){
                        this.statusTempData.map(item => {
                            if(item.id == 1){
                                item.status = 2;
                            }
                            else if(item.id == 2){
                                item.status = 2;
                            }
                            else if(item.id == 3){
                                item.status = 2;
                            }
                            else{
                                item.status = 2;
                            }
                        });
                        clearInterval(this.liveInterval);
                        this.updateStatus(this.statusTempData);
                        this.liveStatusHide();
                    }
    
                }else {
                    if(this.isSchedule) this.liveMessageUpdate.next("Admin notified! A Phlenu support member will assign a delivery personnel during the next business hours. Your order is our priority!");
                    else this.liveMessageUpdate.next("Delivery Prepared");
                }
    
                this.liveSecond++;
                this.liveSecondSub.next(this.liveSecond);
            }, 1000)
        } 
    }

    updateStatus(data){
        this.statusData.next(data);
    }
    

    liveStatusHide(){
        setTimeout(() => {
            // this.isProcessComplated = true;
            this.isProcessComplated.next(true);
        }, 4000);
    }
} 